'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.stopTracker = exports.openSetPasswordModalFromChecker = exports.openConfirmPasswordModalFromChecker = exports.openCompleteAccountModalFromChecker = exports.openLoginModalFromChecker = exports.getTriggerId = exports.isCompleteAccountModalOpen = exports.isLoginModalOpen = exports.isTracking = exports.STOP_TRACKER = exports.OPEN_SET_PASSWORD_MODAL_FROM_CHECKER = exports.OPEN_LOGIN_MODAL_FROM_CHECKER = exports.OPEN_CONFIRM_PASSWORD_MODAL_FROM_CHECKER = exports.OPEN_COMPLETE_ACCOUNT_MODAL_FROM_CHECKER = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _modal = require('../modules/modal');

var _completeAccount = require('../modules/completeAccount');

var _reselect = require('reselect');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var OPEN_COMPLETE_ACCOUNT_MODAL_FROM_CHECKER = exports.OPEN_COMPLETE_ACCOUNT_MODAL_FROM_CHECKER = 'la/ui/shouldLogin/OPEN_COMPLETE_ACCOUNT_MODAL_FROM_CHECKER';
var OPEN_CONFIRM_PASSWORD_MODAL_FROM_CHECKER = exports.OPEN_CONFIRM_PASSWORD_MODAL_FROM_CHECKER = 'la/ui/shouldLogin/OPEN_CONFIRM_PASSWORD_MODAL_FROM_CHECKER';
var OPEN_LOGIN_MODAL_FROM_CHECKER = exports.OPEN_LOGIN_MODAL_FROM_CHECKER = 'la/ui/shouldLogin/OPEN_LOGIN_MODAL_FROM_CHECKER';
var OPEN_SET_PASSWORD_MODAL_FROM_CHECKER = exports.OPEN_SET_PASSWORD_MODAL_FROM_CHECKER = 'la/ui/shouldLogin/OPEN_SET_PASSWORD_MODAL_FROM_CHECKER';
var STOP_TRACKER = exports.STOP_TRACKER = 'la/ui/shouldLogin/STOP_TRACKER';

/* reducer */
var DEFAULT_STATE = {
    completeAccountModalOpen: false,
    confirmPasswordModalOpen: false,
    loginModalOpen: false,
    setPasswordModalOpen: false,
    startTracking: false,
    trigger: ''
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case OPEN_COMPLETE_ACCOUNT_MODAL_FROM_CHECKER:
            return (0, _extends3.default)({}, state, {
                completeAccountModalOpen: true,
                confirmPasswordModalOpen: false,
                loginModalOpen: false,
                setPasswordModalOpen: false,
                startTracking: true,
                trigger: action.trigger
            });
        case OPEN_CONFIRM_PASSWORD_MODAL_FROM_CHECKER:
            // do we need this?
            return (0, _extends3.default)({}, state, {
                completeAccountModalOpen: false,
                confirmPasswordModalOpen: true,
                loginModalOpen: false,
                setPasswordModalOpen: false,
                startTracking: true,
                trigger: action.trigger
            });
        case OPEN_LOGIN_MODAL_FROM_CHECKER:
            return (0, _extends3.default)({}, state, {
                completeAccountModalOpen: false,
                confirmPasswordModalOpen: false,
                loginModalOpen: true,
                setPasswordModalOpen: false,
                startTracking: true,
                trigger: action.trigger
            });
        case OPEN_SET_PASSWORD_MODAL_FROM_CHECKER:
            return (0, _extends3.default)({}, state, {
                completeAccountModalOpen: false,
                confirmPasswordModalOpen: false,
                loginModalOpen: false,
                setPasswordModalOpen: true,
                startTracking: true,
                trigger: action.trigger
            });
        case _modal.COMPLETE_COMPLETE_ACCOUNT_MODAL:
            return (0, _extends3.default)({}, state, {
                completeAccountModalOpen: false
            });
        case _modal.COMPLETE_LOGIN_MODAL:
            return (0, _extends3.default)({}, state, {
                loginModalOpen: false
            });
        case _completeAccount.COMPLETE_ACCOUNT_SUCCESS:
            return (0, _extends3.default)({}, state, {
                completeAccountModalOpen: false
            });
        case _modal.COMPLETE_CONFIRM_PASSWORD_MODAL:
            // TODO there is not action for this
            return (0, _extends3.default)({}, state, {
                confirmPasswordModalOpen: false
            });
        case STOP_TRACKER:
        case _modal.DISMISS_LOGIN_MODAL:
        case _modal.DISMISS_COMPLETE_ACCOUNT_MODAL:
        case _modal.DISMISS_CONFIRM_PASSWORD_MODAL:
        case _modal.DISMISS_SET_PASSWORD_MODAL:
            return (0, _extends3.default)({}, state, {
                completeAccountModalOpen: false,
                confirmPasswordModalOpen: false,
                loginModalOpen: false,
                setPasswordModalOpen: false,
                startTracking: false,
                trigger: ''
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.shouldLogin;
};

var isTracking = exports.isTracking = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.startTracking;
});

var isLoginModalOpen = exports.isLoginModalOpen = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loginModalOpen;
});

var isCompleteAccountModalOpen = exports.isCompleteAccountModalOpen = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.completeAccountModalOpen;
});

var getTriggerId = exports.getTriggerId = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.trigger ? state.trigger : null;
});

/* ACTION CREATORS */
var openLoginModalFromChecker = exports.openLoginModalFromChecker = function openLoginModalFromChecker(trigger) {
    return {
        trigger: trigger,
        type: OPEN_LOGIN_MODAL_FROM_CHECKER
    };
};

var openCompleteAccountModalFromChecker = exports.openCompleteAccountModalFromChecker = function openCompleteAccountModalFromChecker(trigger) {
    return {
        trigger: trigger,
        type: OPEN_COMPLETE_ACCOUNT_MODAL_FROM_CHECKER
    };
};

var openConfirmPasswordModalFromChecker = exports.openConfirmPasswordModalFromChecker = function openConfirmPasswordModalFromChecker(trigger) {
    return {
        trigger: trigger,
        type: OPEN_CONFIRM_PASSWORD_MODAL_FROM_CHECKER
    };
};

var openSetPasswordModalFromChecker = exports.openSetPasswordModalFromChecker = function openSetPasswordModalFromChecker(trigger) {
    return {
        trigger: trigger,
        type: OPEN_SET_PASSWORD_MODAL_FROM_CHECKER
    };
};

var stopTracker = exports.stopTracker = function stopTracker() {
    return {
        type: STOP_TRACKER
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/shouldLogin.js
// module id = 57qU
// module chunks = 46